<template lang="pug">
UpsertBookingPanel(title="Booking details")
  template(v-slot:body="")
    NumberOfPersonsPerSegment(:booking="booking" :classifications="classifications")
    BriqInput(label="Date of visit" disabled v-model="bookingDate" :hideOptionalMarker="true" data-test-id="booking-date-of-visit")
</template>

<script>
import UpsertBookingPanel from '@v/bookings/edit/components/UpsertBookingPanel.vue'
import NumberOfPersonsPerSegment from './PanelBookingDetails/NumberOfPersonsPerSegment.vue'
import { formatShortDateFromUtc } from '@/helpers/dateTimeFormatter.js'

export default {
  name: 'PanelBookingDetails',
  components: { UpsertBookingPanel, NumberOfPersonsPerSegment },
  props: {
    booking: { type: Object, required: true },
    classifications: { type: Array, required: true },
  },
  computed: {
    bookingDate() {
      if (!this.booking.StartTime) return null
      return formatShortDateFromUtc(this.$locale)(this.$timezone)(this.booking.StartTime)
    },
  },
}
</script>
